export default {
	Director:'Director',
	Administrator:'Administrator'
}


// WEBPACK FOOTER //
// ./src/utils/constants/userroles.js